module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0007#abbrs"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0008#ch01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ONE")]), _vm._v(" / Introduction: Higher and Colder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0009#ch02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("TWO")]), _vm._v(" / Gasping Lungs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0010#ch03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THREE")]), _vm._v(" / Frozen Fields")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0011#ch04"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FOUR")]), _vm._v(" / Local Knowledge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0012#ch05"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("FIVE")]), _vm._v(" / Blood on the Mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0013#ch06"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("SIX")]), _vm._v(" / Conclusion: Death and Other Frontiers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0014#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0015#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0016#biblio"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiheggie0017#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314722aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-heggie-0006.vue
// module id = 69
// module chunks = 0